import { useEffect, useState } from 'react';
import { IBackgroundImage } from '../components';
import { createBackgroundImage } from './createBackgroundImage';

export const useBackgroundImage = (imageSrc?: string, dimensions?: { width: number; height: number }) => {
  const [backgroundImage, setBackgroundImage] = useState<IBackgroundImage>();

  // Load background image
  useEffect(() => {
    if (!imageSrc) {
      setBackgroundImage(undefined);
      return;
    }

    const cleanup = createBackgroundImage(imageSrc, setBackgroundImage, dimensions);
    return () => cleanup();
    // dimensions is a new object on each render, but we only want to reload the image if the actual width or height changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageSrc, dimensions?.width, dimensions?.height]);

  return { backgroundImage };
};
